module.exports = __webpack_public_path__ + "media/choosing_a_college/choosing-a-college_header-495b1d48.png";